




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import { ListView } from '@/agiles/components';
import { Workflow, WorkflowPermission } from '@/agiles/common';

@Component
export default class WorkflowPermissionView extends Vue {
  @Prop({default:null}) public workflow : Common.Workflow;
  public items: Common.WorkflowPermission[] = new Array();
  public params: Common.WorkflowPermissionQuery = new Common.WorkflowPermissionQuery();
  public importQuery = new Common.ImportQuery('ワークフロー割当', 'WorkflowPermission');
  public exportQuery = new Common.ExportQuery('ワークフロー割当', this.params);
  public sortOptions: any = [
    { value: 'workflow', text: 'ワークフロー' },
    { value: 'sectionId', text: '区間' },
    { value: 'userId', text: '割当先' },
  ];

  public created(){
    if (this.workflow) this.params.workflow = this.workflow;
  }
  public async getGroupList(workflow: Common.Workflow): Promise<Common.BindItem[]> {

      var result = this.$api.formatter.getOptions('userGroup');
      if (workflow) {
        result = result.concat(workflow.controller.systemHolders);
      } 
      return result;

  }

  public getHolderName(item: Common.WorkflowPermission) {
    let name = item.workflow.getHolderName(item.userId);
    if (name == null) name = this.$api.formatter.formatByList(item.userId, 'userGroup');
    return name;
  }
}
